import React, { Component } from "react";
import { connect } from "react-redux";
import Email from "../components/Email";
import { updateUserData } from "../../../../actions/user.actions";

class EmailContainer extends Component {
  constructor(props) {
    super(props);

    this.memberId = this.props.match.params.memberId;
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(data) {
    if (!this.memberId) {
      this.props.updateUserData(data, "/member/profile", "basicsForm");
    } else {
      const url = /(5|6|7|9)/.test(this.props.user.status_id)
        ? `/admin/member/${this.memberId}/moderation`
        : `/admin/member/approved/${this.memberId}/profile`;

      this.props.updateUserData(data, url, "basicsForm");
    }
  }

  render() {
    return <Email onSubmit={this.handleSubmit} memberId={this.memberId} />;
  }
}

const mapStateToProps = state => {
  return {
    user: state.user.data
  };
};

const mapDispatchToProps = dispatch => ({
  updateUserData: (user, redirect, formName) =>
    dispatch(updateUserData(user, redirect, formName))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmailContainer);



// WEBPACK FOOTER //
// ./src/routes/candidate/profile/containers/EmailContainer.js